import script from "./PublisherAssociateTable.vue?vue&type=script&setup=true&lang=jsx"
export * from "./PublisherAssociateTable.vue?vue&type=script&setup=true&lang=jsx"

import "./PublisherAssociateTable.vue?vue&type=style&index=0&id=d2754c8e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2754c8e"]])

export default __exports__